import React, {useEffect} from 'react';
import {MainList} from './components';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import {Copyright} from '../../components'
import { withRouter } from "react-router";
import { logoutUser } from '../../services/auth.service';
import { useAuth } from "../../context/auth";
import {LOCAL_STORAGE_KEYS} from "../../utils/constants";
import Avatar from "@material-ui/core/Avatar";
import {AccountCircle} from "@material-ui/icons";
import PoweredbyDQ from "../../assets/images/PoweredByDQ_Default.png";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        backgroundColor: '#F4EEEE',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: "transparent",
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    menuButton: {
        marginRight: 36,
        color: theme.palette.primary.main,
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    drawerPaper: {
        height: '96vh',
        position: 'fixed',
        top: '15px',
        left: '9px',
        borderRadius: '20px',
        paddingTop: '10px',
        whiteSpace: 'nowrap',
        width: '230px',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        background: "linear-gradient(to bottom, #FFAC46 0%, #FF5979 50%, #E7466E 100%)",
        color: "white",
        [theme.breakpoints.down('xs')]: {
            width: '14%',
            overflowX: 'hidden',
        },
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    container: {
        paddingBottom: '15px !important',
        padding: '0px !important',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        position:'relative',
        paddingTop:'40px !important',
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: props => (props.isDrawerOpen ? '255px' : '114px'),
        width: props => `calc(95vw - ${props.isDrawerOpen ? '165px' : '30px'})`,

        [theme.breakpoints.down('sm')]: {
            width: '100vw !important',
            marginLeft: '0px !important',
        },
    },
    logoContainer: {
        marginBottom:'40px',
    },
    menuToggle:{
        [theme.breakpoints.down('xs')]: {
            display:'none'
        },
    },
    logo: {
        position:'absolute',
        right: 0,
        height: 80,
        zIndex:'3',
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            height: '60px',
        },
    },
    drawerClose: {
        width: theme.spacing(9),
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
}));


// - List
// - Accounts
// - Config
// - Subscriptions
// - Module UI Conf
// - Badge UI Conf
// - All Modules (Areas)
// - All Badges

const pathToLabelHeadMap = {
    'home': 'DQ Packages',
    'password__change': 'Change Password',
    'ui_config': 'UI Configs',

    'overview': 'Applications Overview',

    'company__view': 'Organization Information',
    'company__update': 'Update Organization Information',

    'application__list': 'Submitted Applications',
    'application__create': 'Create Application',
};


const Main = props => {
    const { children, history, location } = props;
    const [isDrawerOpen, setDrawerOpen] =  React.useState(
        JSON.parse(localStorage.getItem('isDrawerOpen')) || false
    );
    const classes = useStyles({ isDrawerOpen });
    const [labelHeading, setLabelHeading] = React.useState('');
    const { setAuthToken, setAuthUser, authUser } = useAuth();

    const [pathKey, setPathKey] = React.useState('home');

    const anchorRefUserMenu = React.useRef(null);
    const [openUserMenu, setOpenUserMenu] = React.useState(false);
    const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 600);

    // Handle sidebar toggle and persist state
    const handleDrawerToggle = () => {
        setDrawerOpen((prev) => {
            const newState = !prev;
            localStorage.setItem('isDrawerOpen', JSON.stringify(newState));
            return newState;
        });
    };
    // Ensure `isDrawerOpen` is set correctly on refresh
    React.useEffect(() => {
        const storedState = localStorage.getItem('isDrawerOpen');
        if (storedState !== null) {
            setDrawerOpen(JSON.parse(storedState));
        }
    }, []);

    // User Menu Handlers
    const handleUserMenuToggle = () => {
        setOpenUserMenu((prevOpen) => !prevOpen);
    };

    const handleUserMenuClose = (event) => {
        if (anchorRefUserMenu.current && anchorRefUserMenu.current.contains(event.target)) {
            return;
        }

        setOpenUserMenu(false);
    };

    const updateScreenSize = () => {
        setIsMobile(window.innerWidth <= 600);
    };

    const handleChangePassword = (event) => {
        handleUserMenuClose(event);
        history.push('/password/change');
    }

    function handleListKeyDown(event) {

        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenUserMenu(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevUserMenuOpen = React.useRef(openUserMenu);
    React.useEffect(() => {
        if (prevUserMenuOpen.current === true && openUserMenu === false) {
            anchorRefUserMenu.current.focus();
        }

        prevUserMenuOpen.current = openUserMenu;
    }, [openUserMenu]);

    const handleLogout = async () => {
        try {
            await logoutUser();
            setAuthToken(null);
            setAuthUser(null);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.auth_token);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.auth_user);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.refresh_token);
            // history.push('/login');
        } catch (e) {
            // already toasted the error
        }
    };

    useEffect( ()=>{

        const path_parts = location.pathname.split('/');
        console.log('path_parts --> ', path_parts)
        if (path_parts.length > 1) {
            if (path_parts.length < 3) {
                const path_key = path_parts[1];
                if (pathToLabelHeadMap[path_key]) {
                    setLabelHeading(pathToLabelHeadMap[path_key]);
                    setPathKey(path_key);
                }
            } else {
                const path_key = `${path_parts[1]}__${path_parts[2]}`;
                if (pathToLabelHeadMap[path_key]) {
                    setLabelHeading(pathToLabelHeadMap[path_key]);
                    setPathKey(path_key);
                }
            }
        }

    },[location]);

    return (
        <div className={classes.root}>
            <CssBaseline/>
            <div className={classes.logoContainer}>
                <img
                    src={PoweredbyDQ}
                    alt="Logo"
                    className={classes.logo}
                />
            </div>
            {/* AppBar for Mobile */}
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        aria-label="menu"
                        onClick={handleDrawerToggle}
                        className={classes.menuButton}
                    >
                        <MenuIcon/>
                    </IconButton>
                    {/*<Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>*/}
                    {/*    {labelHeading}*/}
                    {/*</Typography>*/}
                </Toolbar>
            </AppBar>

            {/* Drawer */}
            <Drawer
                variant={isMobile ? "temporary" : "permanent"}
                classes={{
                    paper: clsx(classes.drawerPaper, {
                        [classes.drawerClose]: !isDrawerOpen,
                    }),
                }}
                open={isDrawerOpen}
                onClose={handleDrawerToggle} // Only for mobile
                ModalProps={{
                    keepMounted: true, // Improve performance on mobile
                }}
            >
                <div className={classes.menuToggle}>
                    <IconButton style={{color:'#fff',marginLeft:'13px'}} onClick={handleDrawerToggle}>
                        {isDrawerOpen ? <ChevronLeftIcon /> : <MenuIcon />}
                    </IconButton>
                </div>
                <MainList path={pathKey} isDrawerOpen={isDrawerOpen} logoutAction={handleLogout}/>
            </Drawer>
            <main className={classes.content}>
                <Container maxWidth={false} className={classes.container}>
                    {children}
                    <footer className={classes.footer} style={{marginTop: 'auto', paddingTop: '30px'}}>
                        <Box sx={{pt: {xs: '3', sm: '4'}}}>
                            <Copyright/>
                        </Box>
                    </footer>
                </Container>
            </main>
        </div>
    );
}

export default withRouter(Main);